export default __webpack_public_path__ + "static/media/Ellipse12.f04b8e7a.svg";